/* eslint-disable arrow-body-style */
import React from 'react';
import {
  Grid,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  Stack,
  Avatar,
  CircularProgress,
  Typography,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FeedIcon from '@mui/icons-material/Feed';
import { format, parseISO } from 'date-fns';
import Scrollbar from '../scrollbar';
import { TABLE_HEAD } from '../../utils/expenseUtils';

const ExpenseTable = ({
  expenses,
  isLoading,
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  onView,
  onEdit,
  onDelete,
}) => {
  return (
    <Grid item xs={12}>
      <Card>
        <Scrollbar>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  {TABLE_HEAD.map((headCell) => (
                    <TableCell key={headCell.id} align={headCell.alignRight ? 'right' : 'left'}>
                      {headCell.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {isLoading ? (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={TABLE_HEAD.length} sx={{ py: 3 }}>
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (expenses || []).length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={TABLE_HEAD.length} sx={{ py: 3 }}>
                      <Paper sx={{ textAlign: 'center', py: 3 }}>
                        <Typography variant="body2">No expenses found.</Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {expenses.map((expense) => (
                    <TableRow hover key={expense.id}>
                      <TableCell>
                        <Stack direction="row" alignItems="center" spacing={2}>
                          <Avatar>
                            <FeedIcon />
                          </Avatar>
                          <Typography variant="subtitle2">{expense.name}</Typography>
                        </Stack>
                      </TableCell>
                      <TableCell>{expense.category}</TableCell>
                      <TableCell>{expense.amount}</TableCell>
                      <TableCell>{expense.currency}</TableCell>
                      <TableCell>{expense.date ? format(parseISO(expense.date), 'MMM dd, yyyy') : '-'}</TableCell>
                      <TableCell>
                        <Typography variant="body2" noWrap sx={{ maxWidth: 260 }}>
                          {expense.remarks || '-'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={1}>
                          <IconButton size="small" onClick={() => onView(expense)} sx={{ color: 'primary.main' }}>
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton size="small" onClick={() => onEdit(expense)} sx={{ color: 'primary.main' }}>
                            <EditIcon />
                          </IconButton>
                          <IconButton size="small" onClick={() => onDelete(expense)} sx={{ color: 'error.main' }}>
                            <DeleteIcon />
                          </IconButton>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      </Card>
    </Grid>
  );
};

export default ExpenseTable;
